import React from 'react';

import ArrayField from '@rjsf/core/lib/components/fields/ArrayField';

function CustomArrayField(props) {
    var uiSchema = props.uiSchema;

    var widget = uiSchema['ui:widget'];

    if (widget === 'file-multiple') {
        var MultipleUploadWidget = props.registry.widgets['file-multiple'];
        return React.createElement(MultipleUploadWidget, props);
    }

    if (widget === 'table-editable') {
        var TableEditable = props.registry.widgets['table-editable'];
        return React.createElement(TableEditable, props);
    }

    return React.createElement(ArrayField, props);
}

export default CustomArrayField;